// extracted by mini-css-extract-plugin
export default {"bulletin":"bulletin_bulletin__uSBA4","carousel":"bulletin_carousel__aepJ5","item":"bulletin_item__8UXbh"};